export default "__VITE_ASSET__CLvr6UbH__"